import { render, staticRenderFns } from "./sub-standard.vue?vue&type=template&id=245cb59d&scoped=true&"
import script from "./sub-standard.vue?vue&type=script&lang=js&"
export * from "./sub-standard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245cb59d",
  null
  
)

export default component.exports